import {
  Card,
  CardContent,
} from "@/components/ui/card";
import { useAppStore } from "@/stores";
import useSWR from "swr";
import { getAll, getDealstageAvgTimesByCompanyId, getDeal } from "@/lib/supabase";
import { evaluateRiskForReview, prepareDealsForRiskAssessment } from "../lib/risk";
import { getAPI } from "@/lib/api";
import { useParams } from "wouter";
import { AtRiskDealDetails } from "../components/AtRiskDealDetails";
import { Loader } from "@/components/Loader";
import { usePostHog } from "@posthog/react";
import { usePageTimeTracking } from "@/lib/posthog/usePageTimeTracking";

export function RevenueIntelligenceDealDetailsPage() {
  const { id = null } = useParams();
  const { currentUser } = useAppStore((state) => state);

  const posthog = usePostHog();
  usePageTimeTracking("l3", posthog);

  const {
    data: deal,
    // error: dealsError,
    isLoading: isLoadingDeal,
  } = useSWR(
    [
      `query:deal-${id?.toString() ?? "null"}`,
      currentUser?.company_id?.toString() ?? null,
      id ? parseInt(id) : null,
    ],
    ([_, companyId, dealId]) => getDeal(companyId, dealId),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const {
    data: currencies,
    // error: currenciesError,
    isLoading: isLoadingCurrencies,
  } = useSWR(
    [
      'query:currencies',
      currentUser ? currentUser?.company_id.toString() : null,
    ],
    ([_, companyId]) => getAll("currencies", companyId),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  )

  const {
    data: pipelines,
    // error: pipelinesError,
    isLoading: isLoadingPipelines,
  } = useSWR(
    [
      'query:pipelines',
      currentUser ? currentUser?.company_id.toString() : null,
    ],
    ([_, companyId]) => getAPI(`providers/hubspot/pipelines/${companyId}`),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  )

  const {
    data: dealstageAvgTimes,
    // error: dealstageAvgTimesError,
    isLoading: isLoadingdealstageAvgTimes,
  } = useSWR(
    [
      'query:dealstageAvgTimes',
      currentUser ? currentUser?.company_id.toString() : null,
    ],
    ([_, companyId]) => companyId
      ? getDealstageAvgTimesByCompanyId(parseInt(companyId, 10))
      : [],
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  if (
    isLoadingDeal ||
    isLoadingCurrencies ||
    isLoadingPipelines ||
    isLoadingdealstageAvgTimes
  ) return <Loader />;

  const dealsForReview = prepareDealsForRiskAssessment(
    [deal],
    pipelines,
    // @ts-ignore
    currencies,
    // @ts-ignore
    currentUser?.company,
    dealstageAvgTimes,
  );

  const {
    deals,
  } = evaluateRiskForReview(
    dealsForReview,
    currentUser?.company_id,
    pipelines?.results ?? [],
    dealstageAvgTimes ?? [],
    true, // withFullHistoricalRisk
  );

  const dealWithRisks = deals?.[0] ?? undefined;

  return (
    <div className="space-y-4">
      <Card className="border-none bg-transparent">
        <CardContent className="px-0">
          <AtRiskDealDetails
            deal={dealWithRisks}
            dealEmails={[]}
            riskCategory="forecast"
          />
        </CardContent>
      </Card>
    </div>
  );
}
